export default __webpack_public_path__ + "static/media/24.54fb9c8a.jpg";